export function onReady(callback: () => void): void {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
    return;
  }

  callback();
}

export function loadScriptOnce(src: string, async = true): void {
  if (document.querySelector(`script[src="${src}"]`)) return;

  const script = document.createElement('script');
  script.src = src;
  script.async = async;
  document.head.appendChild(script);
}

export function normalize(value: unknown): string {
  return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
}

export function getAuthUser<T = Record<string, unknown>>(): T | null {
  try {
    return JSON.parse(localStorage.getItem('auth_user') || 'null') as T | null;
  } catch {
    return null;
  }
}

export function isAdminUser(): boolean {
  const user = getAuthUser<{ role?: string }>();
  return user?.role === 'admin';
}

export function isProbablyAdminFromStorage(): boolean {
  try {
    return Object.keys(localStorage)
      .map((key) => `${key}:${localStorage.getItem(key)}`)
      .join(' ')
      .toLowerCase()
      .includes('admin');
  } catch {
    return false;
  }
}

export function escapeHtml(value: unknown): string {
  return String(value || '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

export function sanitizeFileName(name: string): string {
  return String(name || 'gallery-image')
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9._-]/g, '')
    .slice(0, 80);
}
